import React, { useEffect } from 'react'

import request from '@function/ajax/request'

export default function GetActivePrivateSales ({ onSuccess, onError, ...props })
{
	useEffect(function ()
	{
		const controller = new AbortController();

		(async function ()
		{
			try
			{
				var response = await request('/private-sales/get-active')
				.config({ controller, keyword: 'ressource' })
				.post({ slug: props.slug });

				onSuccess(response.active_sales || []);
			}
			catch (update)
			{
				if (controller?.signal?.aborted) return;

				if (onError) onError(update);
			}
		})();

		return () => { controller.abort?.(); };
	},
	[]);

	return null;
}